import { Box } from "@mui/material";
import { FC } from "react";
import CustomSelect from "../../../UI/CustomSelect/CustomSelect";
import { styles } from "../stylesRightSidebar";
import { TIME_OPTIONS, PREMIUM_TIME_OPTIONS, TimeRangeValue } from "@/types/timeRanges";

interface FiltersProps {
  value: TimeRangeValue;
  onChange: (val: TimeRangeValue) => void;
  subtype: string[];
  onSubtypeChange: (val: string[]) => void;
  isPremium: boolean;
}
const Filters: FC<FiltersProps> = ({ value, onChange, isPremium, subtype, onSubtypeChange }) => {
  const allOptions = [...TIME_OPTIONS, ...PREMIUM_TIME_OPTIONS];

  const disabledOptions = isPremium ? [] : PREMIUM_TIME_OPTIONS.map((o) => o.label);

  const selectedLabel = value ? (allOptions.find((o) => o.value === value)?.label ?? undefined) : undefined;

  return (
    <Box sx={styles.filtersWrapper}>
      <CustomSelect
        options={["All", "Technical", "Fundamental"]}
        selected={subtype}
        onChange={onSubtypeChange}
        placeholder="All"
        width={144}
        checkblack={true}
        height={36}
        defaultBG="#fff"
      />

      <CustomSelect
        options={allOptions.map((o) => o.label)}
        selected={selectedLabel ? [selectedLabel] : []}
        onChange={(selected) => {
          const label = selected[0];
          const found = allOptions.find((o) => o.label === label);
          onChange((found?.value ?? "") as TimeRangeValue);
        }}
        placeholder="Time Range"
        width={144}
        disabledOptions={disabledOptions}
        multiple={false}
        height={36}
        defaultBG="#fff"
      />
    </Box>
  );
};

export default Filters;
